import React, { Component, useState } from "react"
import { Col, Row, Button, Form, FormGroup, Label, Input } from "reactstrap"
import { Modal } from "react-bootstrap"
import Proptypes, { bool } from "prop-types"
import PhoneInput from "react-phone-input-2"
import Helmet from "react-helmet"
import "react-phone-input-2/lib/style.css"
import ReactNotification from "react-notifications-component"
import "react-notifications-component/dist/theme.css"
import SocialList from "./socialList"
import LoadingAnimation from "../LoadingAnimation/loadingAnimation"

import { store } from "react-notifications-component"

/// import 'animate.css';
const axios = require("axios").default

const ContactUs = props => {
  const [firstName, setFirstName] = useState("")
  const [lastName, setLastName] = useState("")
  const [email, setEmail] = useState("")
  const [phoneNo, setphoneNo] = useState("")
  const [phoneNoCountry, setphoneNoCountry] = useState("Select your country")
  const [country, setCountry] = useState("")
  const [indType, setindType] = useState("")
  const [company, setCompany] = useState("")
  const [message, setMessage] = useState("")
  const [loaderDisplay, setLoaderDisplay] = useState(false)
  const [show, setShow] = useState(false)
  const [offerModal, setOfferModal] = useState(true)
  const handleClose = () => {
    setShow(false)
    setOfferModal(false)
  }
  //get all phone input data and set it to new variable
  const getphoneinputData = (e, country, value) => {
    var newr = country;
    //  phoneCountry = newr;
    console.log(e, country, value)
    //  console.log(newr)
    //  console.log(phoneNoCountry +"old one")
    setphoneNo(e);
    setphoneNoCountry(newr)

  }
  const handleSubmit = e => {
    e.preventDefault()
    setLoaderDisplay(true)
    //   const headers = {
    //       "Access-Control-Allow-Origin": "*",
    //      "Access-Control-Allow-Credentials": "true",
    //      "Access-Control-Allow-Methods": "GET,HEAD,OPTIONS,POST,PUT",
    //     "Access-Control-Allow-Headers": "Origin, X-Requested-With, Content-Type, Accept, Authorization"
    //     }

    axios({
      method: "post",
      url:
        "https://boufjgqaw2.execute-api.us-west-2.amazonaws.com/prod/meetrix/emaildetails",
      data: {
        firstName,
        lastName,
        email,
        phoneNo,
        country,
        indType,
        company,
        message,
      },
    })
      .then(response => {
        console.log("data", response.data)

      })
      .then(() => {
        store.addNotification({
          title: "Message Sent",
          message: "Thank you for Contacting Us.",
          type: "success",
          insert: "bottom",
          container: "bottom-left",
          animationIn: ["animated", "fadeIn"],
          animationOut: ["animated", "fadeOut"],
          dismiss: {
            duration: 3000,
            // onScreen: true,
            // showIcon : true
          },
        })
        setTimeout(props.closeContactus, 800)
        setLoaderDisplay(false)
        setShow(true)
      })
      .then(() => {
        setFirstName("")
        setLastName("")
        setEmail("")
        setphoneNo("")
        setphoneNoCountry("")
        setCountry("")
        setindType("")
        setCompany("")
        setMessage("")
      })

      .catch(error => {
        console.log(error)
      })

    console.log(
      "userDetails",
      firstName,
      lastName,
      email,
      phoneNo,
      phoneNoCountry,
      country,
      indType,
      company,
      message
    )
  }

  const loadPlugin = () => {
    const screenApp = new window.ScreenApp('606d9c373dd85f0012addc95');
    screenApp.mount("#recordingButton");
  }


  return (
    <div className="contact-us">
      <Helmet>
        <script src="https://dev.screenapp.io/plugin-4.4.2.bundle.js" type="text/javascript" >
        </script>
      </Helmet>
      <ReactNotification style={{ zIndex: "1" }} className="notification" />
      <LoadingAnimation display={loaderDisplay} />
      <div className="left">
        <div>
          <h1 className="heading large-font">Contact Us</h1>
          <div className="description small-font">
            Call our tech experts and business advisors to get the exclusive
            consultant service to learn more about how our technologies and
            services can help your business
          </div>
          {/*
                <div className="contact-number-wrapper small-font">
                    <div className="name">WhatsApp</div>
                    <div className="number">+94 70 201 9082</div>
                </div>
              */}
          <div className="contact-number-wrapper small-font">
            <div className="name">phone</div>
            <div className="number">+1 413 225 1434</div>
            <div className="number">+94 7020 19082</div>
          </div>
        </div>
        <Button
          className="start-recording-button"
          color="danger"
          onClick={() => loadPlugin()}>
          Start Recording
          </Button>
        <div className="social-container">
          <SocialList />
        </div>
      </div>
      <div id="recordingButton"></div>
      <div className="right">
        <h1 className="heading large-font">Let Us Contact You</h1>
        <Form onSubmit={handleSubmit}>
          <Row form>
            <Col md={6}>
              <FormGroup>
                <Label for="firstName">First Name</Label>
                <Input
                  required
                  type="text"
                  name="firstname"
                  placeholder="Enter your first name"
                  value={firstName}
                  onChange={e => setFirstName(e.target.value)}
                />
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormGroup>
                <Label for="lastName">Last Name</Label>
                <Input
                  type="text"
                  name="lastname"
                  placeholder="Enter your last name"
                  value={lastName}
                  onChange={e => setLastName(e.target.value)}
                />
              </FormGroup>
            </Col>
          </Row>
          <Row form>
            <Col md={6}>
              <FormGroup>
                <Label for="email">Email</Label>
                <Input
                  required
                  type="email"
                  name="email"
                  placeholder="Enter your email"
                  value={email}
                  onChange={e => setEmail(e.target.value)}
                />
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormGroup>
                <Label for="phone">Phone Number </Label>
                <PhoneInput
                  required
                  country={"us"}
                  placeholder="Enter your phone number"
                  value={phoneNo}
                  onChange={(value, country, e) => getphoneinputData(value, country.name, e)}
                // onChange ={e => console.log(value, country, e, formattedValue)}
                // onChange={e => setphoneNo(console.log(e))}
                // onChange={country=> setphoneNo(console.log(country))}
                />
              </FormGroup>
            </Col>
          </Row>
          <FormGroup>
            <Label for="country">Country</Label>
            <Input
              required
              type="select"
              name="country"
              id="country"
              value={country}
              onChange={e => setCountry(e.target.value)}
            >
              <option value={phoneNoCountry}>{phoneNoCountry}</option>
              <option value="Afghanistan">Afghanistan</option>
              <option value="Åland Islands">Åland Islands</option>
              <option value="Albania">Albania</option>
              <option value="Algeria">Algeria</option>
              <option value="American Samoa">American Samoa</option>
              <option value="Andorra">Andorra</option>
              <option value="Angola">Angola</option>
              <option value="Anguilla">Anguilla</option>
              <option value="Antarctica">Antarctica</option>
              <option value="Antigua and Barbuda">Antigua and Barbuda</option>
              <option value="Argentina">Argentina</option>
              <option value="Armenia">Armenia</option>
              <option value="Aruba">Aruba</option>
              <option value="Australia">Australia</option>
              <option value="Austria">Austria</option>
              <option value="Azerbaijan">Azerbaijan</option>
              <option value="Bahamas">Bahamas</option>
              <option value="Bahrain">Bahrain</option>
              <option value="Bangladesh">Bangladesh</option>
              <option value="Barbados">Barbados</option>
              <option value="Belarus">Belarus</option>
              <option value="Belgium">Belgium</option>
              <option value="Belize">Belize</option>
              <option value="Benin">Benin</option>
              <option value="Bermuda">Bermuda</option>
              <option value="Bhutan">Bhutan</option>
              <option value="Bolivia">Bolivia</option>
              <option value="Bosnia and Herzegovina">
                Bosnia and Herzegovina
              </option>
              <option value="Botswana">Botswana</option>
              <option value="Bouvet Island">Bouvet Island</option>
              <option value="Brazil">Brazil</option>
              <option value="British Indian Ocean Territory">
                British Indian Ocean Territory
              </option>
              <option value="Brunei Darussalam">Brunei Darussalam</option>
              <option value="Bulgaria">Bulgaria</option>
              <option value="Burkina Faso">Burkina Faso</option>
              <option value="Burundi">Burundi</option>
              <option value="Cambodia">Cambodia</option>
              <option value="Cameroon">Cameroon</option>
              <option value="Canada">Canada</option>
              <option value="Cape Verde">Cape Verde</option>
              <option value="Cayman Islands">Cayman Islands</option>
              <option value="Central African Republic">
                Central African Republic
              </option>
              <option value="Chad">Chad</option>
              <option value="Chile">Chile</option>
              <option value="China">China</option>
              <option value="Christmas Island">Christmas Island</option>
              <option value="Cocos (Keeling) Islands">
                Cocos (Keeling) Islands
              </option>
              <option value="Colombia">Colombia</option>
              <option value="Comoros">Comoros</option>
              <option value="Congo">Congo</option>
              <option value="Congo, The Democratic Republic of The">
                Congo, The Democratic Republic of The
              </option>
              <option value="Cook Islands">Cook Islands</option>
              <option value="Costa Rica">Costa Rica</option>
              <option value="Cote D'ivoire">Cote D'ivoire</option>
              <option value="Croatia">Croatia</option>
              <option value="Cuba">Cuba</option>
              <option value="Cyprus">Cyprus</option>
              <option value="Czech Republic">Czech Republic</option>
              <option value="Denmark">Denmark</option>
              <option value="Djibouti">Djibouti</option>
              <option value="Dominica">Dominica</option>
              <option value="Dominican Republic">Dominican Republic</option>
              <option value="Ecuador">Ecuador</option>
              <option value="Egypt">Egypt</option>
              <option value="El Salvador">El Salvador</option>
              <option value="Equatorial Guinea">Equatorial Guinea</option>
              <option value="Eritrea">Eritrea</option>
              <option value="Estonia">Estonia</option>
              <option value="Ethiopia">Ethiopia</option>
              <option value="Falkland Islands (Malvinas)">
                Falkland Islands (Malvinas)
              </option>
              <option value="Faroe Islands">Faroe Islands</option>
              <option value="Fiji">Fiji</option>
              <option value="Finland">Finland</option>
              <option value="France">France</option>
              <option value="French Guiana">French Guiana</option>
              <option value="French Polynesia">French Polynesia</option>
              <option value="French Southern Territories">
                French Southern Territories
              </option>
              <option value="Gabon">Gabon</option>
              <option value="Gambia">Gambia</option>
              <option value="Georgia">Georgia</option>
              <option value="Germany">Germany</option>
              <option value="Ghana">Ghana</option>
              <option value="Gibraltar">Gibraltar</option>
              <option value="Greece">Greece</option>
              <option value="Greenland">Greenland</option>
              <option value="Grenada">Grenada</option>
              <option value="Guadeloupe">Guadeloupe</option>
              <option value="Guam">Guam</option>
              <option value="Guatemala">Guatemala</option>
              <option value="Guernsey">Guernsey</option>
              <option value="Guinea">Guinea</option>
              <option value="Guinea-bissau">Guinea-bissau</option>
              <option value="Guyana">Guyana</option>
              <option value="Haiti">Haiti</option>
              <option value="Heard Island and Mcdonald Islands">
                Heard Island and Mcdonald Islands
              </option>
              <option value="Holy See (Vatican City State)">
                Holy See (Vatican City State)
              </option>
              <option value="Honduras">Honduras</option>
              <option value="Hong Kong">Hong Kong</option>
              <option value="Hungary">Hungary</option>
              <option value="Iceland">Iceland</option>
              <option value="India">India</option>
              <option value="Indonesia">Indonesia</option>
              <option value="Iran, Islamic Republic of">
                Iran, Islamic Republic of
              </option>
              <option value="Iraq">Iraq</option>
              <option value="Ireland">Ireland</option>
              <option value="Isle of Man">Isle of Man</option>
              <option value="Israel">Israel</option>
              <option value="Italy">Italy</option>
              <option value="Jamaica">Jamaica</option>
              <option value="Japan">Japan</option>
              <option value="Jersey">Jersey</option>
              <option value="Jordan">Jordan</option>
              <option value="Kazakhstan">Kazakhstan</option>
              <option value="Kenya">Kenya</option>
              <option value="Kiribati">Kiribati</option>
              <option value="Korea, Democratic People's Republic of">
                Korea, Democratic People's Republic of
              </option>
              <option value="Korea, Republic of">Korea, Republic of</option>
              <option value="Kuwait">Kuwait</option>
              <option value="Kyrgyzstan">Kyrgyzstan</option>
              <option value="Lao People's Democratic Republic">
                Lao People's Democratic Republic
              </option>
              <option value="Latvia">Latvia</option>
              <option value="Lebanon">Lebanon</option>
              <option value="Lesotho">Lesotho</option>
              <option value="Liberia">Liberia</option>
              <option value="Libyan Arab Jamahiriya">
                Libyan Arab Jamahiriya
              </option>
              <option value="Liechtenstein">Liechtenstein</option>
              <option value="Lithuania">Lithuania</option>
              <option value="Luxembourg">Luxembourg</option>
              <option value="Macao">Macao</option>
              <option value="Macedonia, The Former Yugoslav Republic of">
                Macedonia, The Former Yugoslav Republic of
              </option>
              <option value="Madagascar">Madagascar</option>
              <option value="Malawi">Malawi</option>
              <option value="Malaysia">Malaysia</option>
              <option value="Maldives">Maldives</option>
              <option value="Mali">Mali</option>
              <option value="Malta">Malta</option>
              <option value="Marshall Islands">Marshall Islands</option>
              <option value="Martinique">Martinique</option>
              <option value="Mauritania">Mauritania</option>
              <option value="Mauritius">Mauritius</option>
              <option value="Mayotte">Mayotte</option>
              <option value="Mexico">Mexico</option>
              <option value="Micronesia, Federated States of">
                Micronesia, Federated States of
              </option>
              <option value="Moldova, Republic of">Moldova, Republic of</option>
              <option value="Monaco">Monaco</option>
              <option value="Mongolia">Mongolia</option>
              <option value="Montenegro">Montenegro</option>
              <option value="Montserrat">Montserrat</option>
              <option value="Morocco">Morocco</option>
              <option value="Mozambique">Mozambique</option>
              <option value="Myanmar">Myanmar</option>
              <option value="Namibia">Namibia</option>
              <option value="Nauru">Nauru</option>
              <option value="Nepal">Nepal</option>
              <option value="Netherlands">Netherlands</option>
              <option value="Netherlands Antilles">Netherlands Antilles</option>
              <option value="New Caledonia">New Caledonia</option>
              <option value="New Zealand">New Zealand</option>
              <option value="Nicaragua">Nicaragua</option>
              <option value="Niger">Niger</option>
              <option value="Nigeria">Nigeria</option>
              <option value="Niue">Niue</option>
              <option value="Norfolk Island">Norfolk Island</option>
              <option value="Northern Mariana Islands">
                Northern Mariana Islands
              </option>
              <option value="Norway">Norway</option>
              <option value="Oman">Oman</option>
              <option value="Pakistan">Pakistan</option>
              <option value="Palau">Palau</option>
              <option value="Palestinian Territory, Occupied">
                Palestinian Territory, Occupied
              </option>
              <option value="Panama">Panama</option>
              <option value="Papua New Guinea">Papua New Guinea</option>
              <option value="Paraguay">Paraguay</option>
              <option value="Peru">Peru</option>
              <option value="Philippines">Philippines</option>
              <option value="Pitcairn">Pitcairn</option>
              <option value="Poland">Poland</option>
              <option value="Portugal">Portugal</option>
              <option value="Puerto Rico">Puerto Rico</option>
              <option value="Qatar">Qatar</option>
              <option value="Reunion">Reunion</option>
              <option value="Romania">Romania</option>
              <option value="Russian Federation">Russian Federation</option>
              <option value="Rwanda">Rwanda</option>
              <option value="Saint Helena">Saint Helena</option>
              <option value="Saint Kitts and Nevis">
                Saint Kitts and Nevis
              </option>
              <option value="Saint Lucia">Saint Lucia</option>
              <option value="Saint Pierre and Miquelon">
                Saint Pierre and Miquelon
              </option>
              <option value="Saint Vincent and The Grenadines">
                Saint Vincent and The Grenadines
              </option>
              <option value="Samoa">Samoa</option>
              <option value="San Marino">San Marino</option>
              <option value="Sao Tome and Principe">
                Sao Tome and Principe
              </option>
              <option value="Saudi Arabia">Saudi Arabia</option>
              <option value="Senegal">Senegal</option>
              <option value="Serbia">Serbia</option>
              <option value="Seychelles">Seychelles</option>
              <option value="Sierra Leone">Sierra Leone</option>
              <option value="Singapore">Singapore</option>
              <option value="Slovakia">Slovakia</option>
              <option value="Slovenia">Slovenia</option>
              <option value="Solomon Islands">Solomon Islands</option>
              <option value="Somalia">Somalia</option>
              <option value="South Africa">South Africa</option>
              <option value="South Georgia and The South Sandwich Islands">
                South Georgia and The South Sandwich Islands
              </option>
              <option value="Spain">Spain</option>
              <option value="Sri Lanka">Sri Lanka</option>
              <option value="Sudan">Sudan</option>
              <option value="Suriname">Suriname</option>
              <option value="Svalbard and Jan Mayen">
                Svalbard and Jan Mayen
              </option>
              <option value="Swaziland">Swaziland</option>
              <option value="Sweden">Sweden</option>
              <option value="Switzerland">Switzerland</option>
              <option value="Syrian Arab Republic">Syrian Arab Republic</option>
              <option value="Taiwan, Province of China">
                Taiwan, Province of China
              </option>
              <option value="Tajikistan">Tajikistan</option>
              <option value="Tanzania, United Republic of">
                Tanzania, United Republic of
              </option>
              <option value="Thailand">Thailand</option>
              <option value="Timor-leste">Timor-leste</option>
              <option value="Togo">Togo</option>
              <option value="Tokelau">Tokelau</option>
              <option value="Tonga">Tonga</option>
              <option value="Trinidad and Tobago">Trinidad and Tobago</option>
              <option value="Tunisia">Tunisia</option>
              <option value="Turkey">Turkey</option>
              <option value="Turkmenistan">Turkmenistan</option>
              <option value="Turks and Caicos Islands">
                Turks and Caicos Islands
              </option>
              <option value="Tuvalu">Tuvalu</option>
              <option value="Uganda">Uganda</option>
              <option value="Ukraine">Ukraine</option>
              <option value="United Arab Emirates">United Arab Emirates</option>
              <option value="United Kingdom">United Kingdom</option>
              <option value="United States">United States</option>
              <option value="United States Minor Outlying Islands">
                United States Minor Outlying Islands
              </option>
              <option value="Uruguay">Uruguay</option>
              <option value="Uzbekistan">Uzbekistan</option>
              <option value="Vanuatu">Vanuatu</option>
              <option value="Venezuela">Venezuela</option>
              <option value="Viet Nam">Viet Nam</option>
              <option value="Virgin Islands, British">
                Virgin Islands, British
              </option>
              <option value="Virgin Islands, U.S.">Virgin Islands, U.S.</option>
              <option value="Wallis and Futuna">Wallis and Futuna</option>
              <option value="Western Sahara">Western Sahara</option>
              <option value="Yemen">Yemen</option>
              <option value="Zambia">Zambia</option>
              <option value="Zimbabwe">Zimbabwe</option>
            </Input>
          </FormGroup>
          <Row form>
            <Col md={6}>
              <FormGroup>
                <Label for="industry">Industry Type</Label>
                <Input
                  type="select"
                  id="industry"
                  name="industry"
                  value={indType}
                  onChange={e => setindType(e.target.value)}
                >
                  <option value="">Select your Industry Type</option>
                  <option>Education</option>
                  <option>Medicine</option>
                  <option>Healthcare</option>
                  <option>Telecommunication</option>
                  <option>Professional Services</option>
                </Input>
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormGroup>
                <Label for="companyName">Company Name</Label>
                <Input
                  type="text"
                  name="companyName"
                  placeholder="Enter your Company Name"
                  value={company}
                  onChange={e => setCompany(e.target.value)}
                />
              </FormGroup>
            </Col>
          </Row>
          <FormGroup>
            <Label for="message">Message</Label>
            <Input
              required
              type="textarea"
              name="message"
              id="message"
              placeholder="Enter your Message"
              value={message}
              onChange={e => setMessage(e.target.value)}
            />
          </FormGroup>
          <Button className="small-font" color="contact-us">
            SUBMIT
          </Button>
        </Form>
        {/* <Button onClick={() => setShow(true)}> modal open</Button> */}
      </div>
      <Modal
        show={show}
        onHide={handleClose}
        size="lg"
        dialogClassName='custom-dialog'
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton className="modalHeader">
          <Modal.Title id="contained-modal-title-vcenter" className="modalTitle">
            Book a meeting with us if you like to discuss your need directly
        </Modal.Title>
        </Modal.Header>
        <Modal.Body className="modalBody">
          {/* <h4>Centered Modal</h4> */}
          <iframe src="https://calendar.google.com/calendar/selfsched?sstoken=UUktWXp5RDZzdlF2fGRlZmF1bHR8Yjk2NjE3ZmU5MWIzZDhjYjdkMDE4YjIxZDJiODZlZWY" className="calanderIframe"> </iframe>
        </Modal.Body>
        {/* <Modal.Footer>
        <Button onClick={() => handleClose}>Close</Button>
      </Modal.Footer> */}
      </Modal>
    </div>
  )
}

ContactUs.prototype = {
  closeContactus: Proptypes.any,
}

export default ContactUs
